import React, {useEffect, useState} from 'react'
import classnames from "classnames";
import FormFieldComponent from "./FormFieldComponent";

//shouldFilterFieldData is used to limit the form fields being used to only ones found in formConfig (because formData may have more data inside than we want to use in form)
const FormFieldsEditor = ({ className, dataToIgnore, formConfig, formData={}, onChange, onCancel, onSave, shouldFilterFieldData, title }) => {
	const componentClass = 'formFieldsEditor';
	const [localFields, setLocalFields] = useState({});
	const [hasChangesToSave, setHasChangesToSave] = useState(false);
	const classes = classnames(componentClass, className);

	const hydrateLocalFields = () => {
		const fieldsBeingUsed = [];
		(formConfig || []).forEach((group, i) => {
			(group.fields || []).forEach(field => {
				fieldsBeingUsed.push(field.dbField || field.id);
			});
		});

		const updatedLocalFields = {...localFields};
		Object.keys(formData)
			//Only hydrating (keeping) the form with data that is being used in the field. Data that is ignored or not being used will be filtered out
			.filter(k => !(dataToIgnore || []).includes(k) && (!shouldFilterFieldData || fieldsBeingUsed.includes(k))) //TODO: consider also filtering fields on backend
			.forEach(fieldKey => {
				updatedLocalFields[fieldKey] = formData[fieldKey];
			});
		setLocalFields(updatedLocalFields);
		setHasChangesToSave(false);
	};

	useEffect(() => hydrateLocalFields(), [formData]);

	const onFieldChange = (value, fieldKey) => {
		setLocalFields({
			...localFields,
			[fieldKey]: value
		});
		setHasChangesToSave(true);
		onChange && onChange(fieldKey, value);
	};

	const onSaveClicked = () => {
		onSave && onSave(localFields);
	};

	return <div className={classes}>
		{ title && <h3 className={`${componentClass}__title`}>{ title }</h3> }
		<section className={`${componentClass}__fields`}>
			{
				(formConfig || []).map((group, i) => {
					const groupClassName = classnames(`${componentClass}__fieldGroup`, (group.props || {}).className || '');
					return <div key={group.key || `group-${i}`} {...(group.props || {})} className={groupClassName}>
						{ group?.name && <h4>{ group.name }</h4> }
						{ group?.description && <p>{ group.description }</p> }
						<fieldset>
							{ (group.fields || []).map(fieldConfig => {
								const fieldKey = fieldConfig?.dbField || fieldConfig?.id;
								return <FormFieldComponent
									fieldConfig={fieldConfig}
									onFieldChange={v => onFieldChange(v, fieldKey)}
									data={localFields}
									className={`${componentClass}__field`}
									value={localFields[fieldKey]}
								/>
							})}
						</fieldset>
					</div>
				})
			}
		</section>
		<div className="nuButtonGroup">
			{ onSave && <button className="btn btn-block btn-primary" onClick={onSaveClicked} disabled={!hasChangesToSave} >Save</button> }
			{ onCancel && <button className="btn btn-block btn-outline-black" onClick={onCancel}>Cancel</button>}
		</div>
	</div>;
}

export default FormFieldsEditor;
//TODO: document shapes


